import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'ml-not-found',
  template: `
    <ml-logo-card>
      <div class="padding-bottom-16">
        <div class="mat-headline">
          {{ 'page not found' | translate | sentancecase }}
        </div>
        <button mat-raised-button (click)="goBackToApp()" color="accent">
          {{ 'go back to the app' | translate | uppercase }}
        </button>
      </div>
    </ml-logo-card>
  `,
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {}

  goBackToApp() {
    this.router.navigate(['']);
  }
}
